
var ROWS = [
  ['Drink 15 minutes before training', '✓','✓','✓','—'],
  ['Light enough to drink and go',     '✓','✓','✓','—'],
  ['No blender, no dishes',            '✓','✓','✓','—'],
  ['Carbohydrates',                    '✓','—','Some','✓'],
  ['Protein',                          '✓','—','Some','✓'],
  ['Electrolytes',                     '✓','—','Some','Some'],
  ['Caffeine',                         '✓','✓','✓','—']
];

function esc(t){ var d=document.createElement('div'); d.textContent=t; return d.innerHTML; }

function cell(v,brek){var multi=(v.length>1);var size=multi?'12.5px':'19px';var weight=multi?'700':(brek?'900':'800');var col=brek?'#2E5CE6':'#4B473E';var extra=multi?'letter-spacing:.06em;text-transform:uppercase;':'';return '<span class="g" style="font-size:'+size+';font-weight:'+weight+';color:'+col+';'+extra+'">'+v+'</span>';}

function renderRows(){
  var host=document.getElementById('cmpRows'); if(!host) return;
  var h='';
  for (var i=0;i<ROWS.length;i++){
    var r=ROWS[i];
    h += '<tr><td style="text-align:left;font-size:15px;color:#1C1A16;font-weight:600;">'+esc(r[0])+'</td>'
      +  '<td style="background:rgba(46,92,230,.07);">'+cell(r[1],true)+'</td>'
      +  '<td>'+cell(r[2],false)+'</td>'
      +  '<td>'+cell(r[3],false)+'</td>'
      +  '<td>'+cell(r[4],false)+'</td></tr>';
  }
  host.innerHTML = h;
}

function brekValidate(e){var f=e.currentTarget||e.target;var input=f.querySelector('[data-brek-email]');var err=f.querySelector('[data-brek-err]');if(!input)return true;var v=(input.value||'').trim();if(!v||!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v)){e.preventDefault();if(err){err.textContent='Enter a valid email address.';err.style.display='block';}input.setAttribute('aria-invalid','true');input.style.borderColor='#E8543F';input.focus();return false;}if(err){err.style.display='none';}input.removeAttribute('aria-invalid');return true;}

function doSnooze(){
  document.getElementById('snoozeWrap').style.display='none';
  var ht=document.getElementById('heroThanks'); if(ht)ht.style.display='none';
  document.getElementById('doneWrap').style.display='block';
  document.getElementById('clock').textContent='06:00';
  document.getElementById('clock').style.color='#2E5CE6';
  document.getElementById('clockNote').textContent='Your new alarm';
}
function undoSnooze(){
  document.getElementById('doneWrap').style.display='none';
  var ht=document.getElementById('heroThanks'); if(ht)ht.style.display='none';
  document.getElementById('snoozeWrap').style.display='block';
  document.getElementById('clock').textContent='05:30';
  document.getElementById('clock').style.color='#1C1A16';
  document.getElementById('clockNote').textContent='Your current alarm';
}

/* kinetic headline */
var mx=-900,my=-900,fx=-900,fy=-900;
var FINE = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
var MOVED=false;
document.addEventListener('mousemove',function(e){mx=e.clientX;my=e.clientY;MOVED=true;});
(function loop(){
  fx += (mx-fx)*0.16; fy += (my-fy)*0.16;
  var L = (FINE && MOVED) ? document.querySelectorAll('.kin') : [];
  for (var i=0;i<L.length;i++){
    var el=L[i], r=el.getBoundingClientRect();
    var d=Math.hypot(r.left+r.width/2-fx, r.top+r.height/2-fy);
    var t=Math.max(0,1-d/320);
    el.style.fontWeight=String(Math.round(620+t*280));
    el.style.transform='translateY('+(-t*18)+'px)';
    el.style.color = t>0.62 ? '#2E5CE6' : '';
  }
  requestAnimationFrame(loop);
})();

renderRows();

/* BREK: Shopify appends #contact_form to the form action, which makes the post-submit
   redirect jump the page. Strip it. Then bind validation, and if we've come back from a
   successful signup (?customer_posted=true) switch everything to its confirmed state. */
function show(id,how){var e=document.getElementById(id);if(e)e.style.display=how;}
function showSignedUp(){
  show('snoozeWrap','none'); show('doneWrap','none'); show('heroThanks','block');
  var c=document.getElementById('clock'); if(c){c.textContent='06:00';c.style.color='#2E5CE6';}
  var n=document.getElementById('clockNote'); if(n){n.textContent='Your new alarm';}
  show('waitFormWrap','none'); show('waitThanks','block');
  var host=document.querySelector('.brek-site>div');
  if(host&&!document.getElementById('signupBanner')){
    var b=document.createElement('div');
    b.id='signupBanner';
    b.setAttribute('role','status');
    b.style.cssText='background:#1C1A16;color:#F3EFE4;padding:18px 24px;display:flex;align-items:center;justify-content:center;gap:14px;text-align:center;font-family:Inter,Arial,sans-serif;';
    b.innerHTML='<span style="display:inline-flex;align-items:center;justify-content:center;width:26px;height:26px;border-radius:50%;background:#2E5CE6;flex-shrink:0;"><svg width="15" height="15" viewBox="0 0 24 24" fill="none"><path d="M5 12.5 L10 17.5 L19 7" stroke="#F3EFE4" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></path></svg></span>'
      +'<span style="font-size:15.5px;"><strong style="font-family:Geist,Arial,sans-serif;font-weight:800;">You\'re on the list.</strong> We\'ll email you the moment BREK drops. Nothing else.</span>';
    host.insertBefore(b,host.firstChild);
  }
}

/* Safety net: the theme's scroll override breaks the browser's lazy-load viewport
   calculation, so any below-fold image left on loading=lazy can stall at naturalWidth 0
   and never paint. Force every in-section image to load eagerly. */
function brekForceEager(){
  var imgs=document.querySelectorAll('.brek-site img[loading="lazy"]');
  for(var i=0;i<imgs.length;i++){
    var im=imgs[i];
    im.setAttribute('loading','eager');
    if(!im.complete||im.naturalWidth===0){ var s=im.src; im.src=''; im.src=s; }
  }
}

document.addEventListener('DOMContentLoaded',function(){
  brekForceEager();
  var fs=document.querySelectorAll('form.brek-wait');
  for(var i=0;i<fs.length;i++){
    fs[i].setAttribute('action',(fs[i].getAttribute('action')||'/contact').split('#')[0]);
    fs[i].addEventListener('submit',brekValidate);
  }
  if(/[?&]customer_posted=true/.test(window.location.search)){ showSignedUp(); }
});
